import axios from 'axios';
import React, { Component } from 'react';
import ContentExperencieLenguages from '../atoms/ContentExperencieLenguages';
import SectionLoadingLoader from './SectionLoadingLoader';

class SectionExperienceInTheThecnology extends Component {
    constructor(props) {
        super(props)

        this.state = {
            dataThecnologyExperience: []
        }
    }

    componentDidMount() {
        axios.get("https://raw.githubusercontent.com/eliud-cesar/apis-portfolio/master/experencie-lenguages.json")
            .then(resp => {
                this.setState ({
                    dataThecnologyExperience: resp.data
                })
            })
    }

    render() {
        const { dataThecnologyExperience } = this.state
        return(
            <>
            {
                dataThecnologyExperience.length === 0 
                ? < SectionLoadingLoader />
                : dataThecnologyExperience.map(u => (
                    < ContentExperencieLenguages
                        Title = {u.NameThecnology}
                        Img = {u.ImageExperencie}
                        Width = {u.Percentage}
                    />
                ))
            }
            </>
        )
    }
}

export default SectionExperienceInTheThecnology;